import React, { useState, useEffect } from 'react';
import { Card, Button, Typography, Space, Tag, Divider } from 'antd';
import { EyeOutlined, EyeInvisibleOutlined, DeleteOutlined, ReloadOutlined, SettingOutlined, CloseOutlined } from '@ant-design/icons';

const { Text, Paragraph } = Typography;

const DebugPanel = () => {
    const [showToken, setShowToken] = useState(false);
    const [tokenInfo, setTokenInfo] = useState(null);
    const [isVisible, setIsVisible] = useState(false); // 默认关闭

    const updateTokenInfo = () => {
        const token = localStorage.getItem('token');
        setTokenInfo({
            hasToken: !!token,
            token: token,
            tokenLength: token ? token.length : 0,
            timestamp: new Date().toLocaleString()
        });
    };

    useEffect(() => {
        updateTokenInfo();
        // 每秒更新一次
        const interval = setInterval(updateTokenInfo, 1000);
        return () => clearInterval(interval);
    }, []);

    const clearToken = () => {
        localStorage.removeItem('token');
        updateTokenInfo();
        window.location.reload();
    };

    const setTestToken = () => {
        localStorage.setItem('token', 'test-token-' + Date.now());
        updateTokenInfo();
        window.location.reload();
    };

    // 如果不可见，只显示切换按钮
    if (!isVisible) {
        return (
            <Button
                type="primary"
                shape="circle"
                icon={<SettingOutlined />}
                onClick={() => setIsVisible(true)}
                style={{
                    position: 'fixed',
                    bottom: 20,
                    right: 20,
                    zIndex: 9999,
                    width: 40,
                    height: 40,
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                }}
                title="Open Debug Panel"
            />
        );
    }

    return (
        <Card 
            title={
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>🔧 Debug Panel</span>
                    <Button
                        type="text"
                        size="small"
                        icon={<CloseOutlined />}
                        onClick={() => setIsVisible(false)}
                        style={{ marginRight: -8 }}
                    />
                </div>
            }
            size="small"
            style={{ 
                position: 'fixed', 
                bottom: 20, 
                right: 20, 
                width: 300,
                zIndex: 9999,
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
            }}
        >
            <Space direction="vertical" style={{ width: '100%' }}>
                <div>
                    <Text strong>Login Status: </Text>
                    <Tag color={tokenInfo?.hasToken ? 'green' : 'red'}>
                        {tokenInfo?.hasToken ? 'Logged In' : 'Not Logged In'}
                    </Tag>
                </div>

                <div>
                    <Text strong>Token Length: </Text>
                    <Text>{tokenInfo?.tokenLength || 0}</Text>
                </div>

                <div>
                    <Text strong>Last Update: </Text>
                    <Text type="secondary" style={{ fontSize: 12 }}>
                        {tokenInfo?.timestamp}
                    </Text>
                </div>

                {tokenInfo?.hasToken && (
                    <div>
                        <Text strong>Token: </Text>
                        <Button 
                            type="text" 
                            size="small"
                            icon={showToken ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                            onClick={() => setShowToken(!showToken)}
                        />
                        {showToken && (
                            <Paragraph 
                                copyable 
                                style={{ 
                                    fontSize: 10, 
                                    wordBreak: 'break-all',
                                    margin: '8px 0 0 0',
                                    padding: 8,
                                    background: '#f5f5f5',
                                    borderRadius: 4
                                }}
                            >
                                {tokenInfo.token}
                            </Paragraph>
                        )}
                    </div>
                )}

                <Divider style={{ margin: '8px 0' }} />

                <Space>
                    <Button 
                        size="small" 
                        icon={<ReloadOutlined />}
                        onClick={() => window.location.reload()}
                    >
                        Reload
                    </Button>
                    <Button 
                        size="small" 
                        icon={<DeleteOutlined />}
                        danger
                        onClick={clearToken}
                    >
                        Clear Token
                    </Button>
                </Space>

                <Button 
                    size="small" 
                    type="dashed"
                    onClick={setTestToken}
                    block
                >
                    Set Test Token
                </Button>
            </Space>
        </Card>
    );
};

export default DebugPanel; 